

























import { namespace } from 'vuex-class';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import { IUpsell } from '@/interfaces/Upsell';
import { IOrder } from '@/interfaces/Order';
import { IPayment } from '@/interfaces/Payment';

import { EPaymentMethod, EPaymentMethodTypes } from '@/helpers/enums';

import Modal from '@/shared/components/Modal/Modal.vue';
import UpsellPayment from './UpsellPayment.vue';
import UpsellPaymentLoading from './UpsellPaymentLoading.vue';

const AppModule = namespace('App');
const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    Modal,
    UpsellPayment,
    UpsellPaymentLoading
  }
})
export default class UpsellPaymentModal extends Vue {
  @Prop({ default: false })
  private visibility: boolean;

  @Prop()
  private slug: string;

  @Prop()
  private upsell: IUpsell;

  @Prop()
  private order: IOrder;

  @CheckoutModule.State('offerLoading')
  private loading!: boolean;


  @AppModule.Action('prepareUpsell')
  private prepareUpsell: Function;

  @AppModule.Mutation
  private setPaymentMethodSelected: Function;

  @CheckoutModule.Getter('selectedOfferPayment')
  private payment: IPayment;

  private radioGroup: any = 0;

  @Watch('visibility')
  visibilityChange(val: boolean) {
    document.querySelector('html')!.classList.toggle('overflow-y-hidden', val);
  }

  private close() {
    this.$emit('close');
  }

  public updateUpsell(payload: any) {
    if (this.upsell.id && this.order.id) {
      this.prepareUpsell({
        upsellId: this.upsell.id,
        orderId: this.order.id,
        params: payload,
      });
    }
  }

  private mounted() {
    if (this.upsell.id && this.order.id) {
      this.setPaymentMethodSelected(EPaymentMethodTypes.creditCard);
      this.prepareUpsell({
        upsellId: this.upsell.id,
        orderId: this.order.id,
        params: {
          payment_method: EPaymentMethodTypes.creditCard
        },
      });
    }
  }
}
